import { render, staticRenderFns } from "./app-bar.vue?vue&type=template&id=961fe9ce&"
import script from "./app-bar.vue?vue&type=script&lang=js&"
export * from "./app-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports